import BOS from './BOS.jpg';
import fanboy from './fanboy.jpg';
import jzsmoke from './jzsmoke.jpg';
import pistachio from './pistachio.jpg';
import speared from './speared.jpg';
import ferrari from './ferrari.jpg';
import karina from './karina.jpg';
import pumpkins from './pumpkins.jpg';
import splatter from './splatter.jpg';
import flower from './flower.jpg';
import kaylarado from './kaylarado.jpg';
import pumpkinsale from './pumpkinsale.jpg';
import states_swim from './states_swim.jpg';
import adirondack from './adirondack.jpg';
import flowerA1 from './flowerA1.jpg';
import ked from './ked.jpg';
import rain from './rain.jpg';
import sujit from './sujit.jpg';
import bee from './bee.jpg';
import flowerA2 from './flowerA2.jpg';
import league from './league.jpg';
import raspberry_snowman from './raspberry_snowman.jpg';
import summer_dreamin from './summer_dreamin.jpg';
import big_beach from './big_beach.jpg';
import fountain from './fountain.jpg';
import look_up from './look_up.jpg';
import reminiscent from './reminiscent.jpg';
import the_road_goes_ever_on from './the_road_goes_ever_on.jpg';
import bobert from './bobert.jpg';
import four_years from './four_years.jpg';
import moka2 from './moka2.jpg';
import riho from './riho.jpg';
import thomas from './thomas.jpg';
import briana from './briana.jpg';
import george_laughing from './george_laughing.jpg';
import mokanero from './mokanero.jpg';
import road_to_the_top from './road_to_the_top.jpg';
import tsdlau from './tsdlau.jpg';
import bronze from './bronze.jpg';
import graduation from './graduation.jpg';
import mya from './mya.jpg';
import sarah from './sarah.jpg';
import wendy from './wendy.jpg';
import bu from './bu.jpg';
import grandmaster from './grandmaster.jpg';
import nemo from './nemo.jpg';
import shadow_light from './shadow_light.jpg';
import wesley from './wesley.jpg';
import butterfly from './butterfly.jpg';
import guru from './guru.jpg';
import packing from './packing.jpg';
import sheep from './sheep.jpg';
import zenbonsakura from './zenbonsakura.jpg';
import castaway from './castaway.jpg';
import hocr from './hocr.jpg';
import painter from './painter.jpg';
import shoes_optional from './shoes_optional.jpg';
import comm_ave from './comm_ave.jpg';
import joseph_nyc from './joseph_nyc.jpg';
import parrot from './parrot.jpg';
import snowmiri from './snowmiri.jpg';
import dem_boiz from './dem_boiz.jpg';
import just_chillin from './just_chillin.jpg';
import peeking_red from './peeking_red.jpg';
import snowsalt from './snowsalt.jpg';
import edemame from './edemame.jpg';
import jz2 from './jz2.jpg';
import piano_keys from './piano_keys.jpg';
import sophie from './sophie.jpeg';

export const Pictures = [
  { image: BOS, id: 'BOS' },
  { image: fanboy, id: 'fanboy' },
  { image: jzsmoke, id: 'jzsmoke' },
  { image: pistachio, id: 'pistachio' },
  { image: speared, id: 'speared' },
  { image: ferrari, id: 'ferrari' },
  { image: karina, id: 'karina' },
  { image: pumpkins, id: 'pumpkins' },
  { image: splatter, id: 'splatter' },
  { image: flower, id: 'flower' },
  { image: kaylarado, id: 'kaylarado' },
  { image: pumpkinsale, id: 'pumpkinsale' },
  { image: states_swim, id: 'states_swim' },
  { image: adirondack, id: 'adirondack' },
  { image: flowerA1, id: 'flowerA1' },
  { image: ked, id: 'ked' },
  { image: rain, id: 'rain' },
  { image: sujit, id: 'sujit' },
  { image: bee, id: 'bee' },
  { image: flowerA2, id: 'flowerA2' },
  { image: league, id: 'league' },
  { image: raspberry_snowman, id: 'raspberry_snowman' },
  { image: summer_dreamin, id: 'summer_dreamin' },
  { image: big_beach, id: 'big_beach' },
  { image: fountain, id: 'fountain' },
  { image: look_up, id: 'look_up' },
  { image: reminiscent, id: 'reminiscent' },
  { image: the_road_goes_ever_on, id: 'the_road_goes_ever_on' },
  { image: bobert, id: 'bobert' },
  { image: four_years, id: 'four_years' },
  { image: moka2, id: 'moka2' },
  { image: riho, id: 'riho' },
  { image: thomas, id: 'thomas' },
  { image: briana, id: 'briana' },
  { image: george_laughing, id: 'george_laughing' },
  { image: mokanero, id: 'mokanero' },
  { image: road_to_the_top, id: 'road_to_the_top' },
  { image: tsdlau, id: 'tsdlau' },
  { image: bronze, id: 'bronze' },
  { image: graduation, id: 'graduation' },
  { image: mya, id: 'mya' },
  { image: sarah, id: 'sarah' },
  { image: wendy, id: 'wendy' },
  { image: bu, id: 'bu' },
  { image: grandmaster, id: 'grandmaster' },
  { image: nemo, id: 'nemo' },
  { image: shadow_light, id: 'shadow_light' },
  { image: wesley, id: 'wesley' },
  { image: butterfly, id: 'butterfly' },
  { image: guru, id: 'guru' },
  { image: packing, id: 'packing' },
  { image: sheep, id: 'sheep' },
  { image: zenbonsakura, id: 'zenbonsakura' },
  { image: castaway, id: 'castaway' },
  { image: hocr, id: 'hocr' },
  { image: painter, id: 'painter' },
  { image: shoes_optional, id: 'shoes_optional' },
  { image: comm_ave, id: 'comm_ave' },
  { image: joseph_nyc, id: 'joseph_nyc' },
  { image: parrot, id: 'parrot' },
  { image: snowmiri, id: 'snowmiri' },
  { image: dem_boiz, id: 'dem_boiz' },
  { image: just_chillin, id: 'just_chillin' },
  { image: peeking_red, id: 'peeking_red' },
  { image: snowsalt, id: 'snowsalt' },
  { image: edemame, id: 'edemame' },
  { image: jz2, id: 'jz2' },
  { image: piano_keys, id: 'piano_keys' },
  { image: sophie, id: 'sophie' }
];
